import { axiosInstance } from '~/services';

import type {
  TypePostUserLoginCheckTwoFactorCodeParams,
  TypePostUserLoginCheckTwoFactorCodeResponse,
} from '~/types/auth.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * 로그인 2단계 코드 인증 요청 API
 */
const usePostUserLoginCheckTwoFactorCode = () => {
  const endPoint = '/api-owner/user/login/check/twofactor-code';

  const postUserLoginCheckTwoFactorCode = async (params: TypePostUserLoginCheckTwoFactorCodeParams) => {
    return axiosInstance
      .post<TypePostUserLoginCheckTwoFactorCodeResponse>(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postUserLoginCheckTwoFactorCode };
};

export default usePostUserLoginCheckTwoFactorCode;
